export const UserDeadline = "user-deadline"
export const OpenTxid = "open-txid"
export const PaymentTxid = "payment-txid"
export const SavedStateKey = "last-state"
export const SessionId = "session-id"